var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBankbag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.1875V2.625C15.75 1.39453 14.7305 0.375 13.5 0.375H3.375C1.47656 0.375 0 1.88672 0 3.75V12.75C0 14.6484 1.47656 16.125 3.375 16.125H15.75C16.9805 16.125 18 15.1406 18 13.875V5.4375C18 4.20703 16.9805 3.1875 15.75 3.1875ZM16.3125 13.875C16.3125 14.1914 16.0312 14.4375 15.75 14.4375H3.375C2.42578 14.4375 1.6875 13.6992 1.6875 12.75V3.75C1.6875 2.83594 2.42578 2.0625 3.375 2.0625H13.5C13.7812 2.0625 14.0625 2.34375 14.0625 2.625V3.75H3.9375C3.62109 3.75 3.375 4.03125 3.375 4.3125C3.375 4.62891 3.62109 4.875 3.9375 4.875H15.75C16.0312 4.875 16.3125 5.15625 16.3125 5.4375V13.875ZM13.5 8.25C12.8672 8.25 12.375 8.77734 12.375 9.375C12.375 10.0078 12.8672 10.5 13.5 10.5C14.0977 10.5 14.625 10.0078 14.625 9.375C14.625 8.77734 14.0977 8.25 13.5 8.25Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBankbag);
export default __webpack_public_path__ + "static/media/ic-bankbag.65801430adec3590408177d85ae724cc.svg";
export { ForwardRef as ReactComponent };